export default "__VITE_ASSET__BzKR5Np8__"